import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { Button, Grid } from "@mui/material";
import { textFieldStyle } from "../../../../assets/styles/styles";
const useOn = (on) => {
    return useMemo(() => {
        const containerSx = JSON.parse(JSON.stringify(textFieldStyle));
        containerSx.height = '100%';
        const btnSx = { textTransform: 'none' };
        if (on) {
            containerSx['& *'].color = '#eee1e1!important';
            btnSx.fontSize = '1.0rem';
        }
        return { containerSx, btnSx };
    }, [on]);
};
export const NavButton = ({ on, ...props }) => {
    const { containerSx, btnSx } = useOn(on);
    return (_jsx(Grid, { item: true, children: _jsx(Grid, { container: true, alignItems: 'center', sx: containerSx, children: _jsx(Button, { component: 'a', href: props.href, onClick: (e) => {
                    e.preventDefault();
                    props.link();
                }, sx: btnSx, children: props.children }, void 0) }, void 0) }, void 0));
};
//# sourceMappingURL=NavButton.js.map